/**
 * Aurié Luxe Co. — Collection Page JS
 * File: assets/aurie-collection.js
 */

(function ($) {
  'use strict';

  $(function () {

    var $section = $('.main-collection');
    if (!$section.length) return;

    var config = window.AurieCollection && window.AurieCollection.config
      ? window.AurieCollection.config
      : {
          sortUrl: window.location.pathname,
          currentSort: 'manual',
          descriptions: {}
        };

    /* ── State ───────────────────────────────────────────── */
   var currentFilter = $('.mc-filter-btn--active').data('filter') || 'all';

    /* ── Elements ────────────────────────────────────────── */
    var $filterBtns   = $section.find('.mc-filter-btn');
    var $cards        = $section.find('.mc-card');
    var $grid         = $section.find('#mc-grid');
    var $countEl      = $section.find('#mc-count');
    var $sortSel      = $section.find('#mc-sort');
    var $descBanner   = $section.find('#mc-desc-banner');
    var $descTitle    = $descBanner.find('.main-collection__desc-title');
    var $descText     = $descBanner.find('.main-collection__desc-text');
    var $emptyEl      = $section.find('#mc-empty');
    var $filterToggle = $section.find('#mc-filter-toggle');
    var $filterDrawer = $section.find('#mc-filters');

    /* ── Filter Logic ────────────────────────────────────── */
    function applyFilter() {

      var visible = 0;

      $cards.each(function () {

        var $card = $(this);
        var groups = ($card.data('groups') || '')
          .toString()
          .split(' ');

        if (
          currentFilter === 'all' ||
          groups.indexOf(currentFilter) !== -1
        ) {
          $card.removeClass('is-hidden');
          visible++;
        } else {
          $card.addClass('is-hidden');
        }

      });

      $countEl.text(
        visible + (visible === 1 ? ' product' : ' products')
      );

      if (
        currentFilter !== 'all' &&
        config.descriptions[currentFilter]
      ) {

        var label = $filterBtns
          .filter('.mc-filter-btn--active')
          .text()
          .trim();

        $descTitle.text(label + ' Collection');
        $descText.text(config.descriptions[currentFilter]);

        $descBanner.stop(true, true).slideDown(180);

      } else if (currentFilter === 'all') {

    var title = window.AurieCollection.defaultTitle || '';
    var description = window.AurieCollection.defaultDescription || '';

    $descTitle.text(title);

    if (description.trim()) {
        $descText.html(description).show();
    } else {
        $descText.hide().empty();
    }

    $descBanner.stop(true, true).slideDown(180);
}

      if (visible === 0) {
        $emptyEl.removeAttr('hidden').show();
      } else {
        $emptyEl.attr('hidden', '').hide();
      }

    }

    /* ── Sort Logic ──────────────────────────────────────── */
    function applySort(sortVal) {

      var url = new URL(window.location.href);

      url.searchParams.set('sort_by', sortVal);

      window.location.href = url.toString();

    }

    /* ── Client Side Sort ────────────────────────────────── */
    function clientSort(sortVal) {

      var $allCards = $grid.find('.mc-card').detach();

      var sorted = $allCards.toArray().sort(function (a, b) {

        var aPrice = parseFloat($(a).data('price')) || 0;
        var bPrice = parseFloat($(b).data('price')) || 0;

        var aDate = parseInt($(a).data('date'), 10) || 0;
        var bDate = parseInt($(b).data('date'), 10) || 0;

        if (sortVal === 'price-ascending') {
          return aPrice - bPrice;
        }

        if (sortVal === 'price-descending') {
          return bPrice - aPrice;
        }

        if (sortVal === 'created-descending') {
          return bDate - aDate;
        }

        return 0;

      });

      $grid.append(sorted);

      $cards = $section.find('.mc-card');

      applyFilter();

    }

    /* ── AJAX Collection Load ────────────────────────────── */
/* ── AJAX Collection Load ────────────────────────────── */
function loadCollection(url, pushState = true) {

    $grid.addClass('is-loading');

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',

        success: function (response) {

            var html = $('<div>').html(response);

            /* --------------------------------------------------
               HERO
            -------------------------------------------------- */

            var $newHero = html.find('.main-collection__hero');

            if ($newHero.length) {
                $('.main-collection__hero').replaceWith($newHero);
            }

            /* --------------------------------------------------
               DESCRIPTION
            -------------------------------------------------- */

            var $newDesc = html.find('#mc-desc-banner');

            if ($newDesc.length) {
                $('#mc-desc-banner').replaceWith($newDesc);
            }

            /* --------------------------------------------------
               PRODUCT GRID
            -------------------------------------------------- */

            var $newGrid = html.find('#mc-grid');

            if ($newGrid.length) {
                $('#mc-grid').replaceWith($newGrid);
            }

            /* --------------------------------------------------
               PRODUCT COUNT
            -------------------------------------------------- */

            var newCount = html.find('#mc-count').text();

            if (newCount) {
                $('#mc-count').text(newCount);
            }

            /* --------------------------------------------------
               SORT
            -------------------------------------------------- */

            var newSort = html.find('#mc-sort').val();

            if (newSort) {
                $('#mc-sort').val(newSort);
            }

            /* --------------------------------------------------
               UPDATE DEFAULT VALUES
            -------------------------------------------------- */


            /* --------------------------------------------------
               REFRESH ELEMENT REFERENCES
            -------------------------------------------------- */

            $grid = $('#mc-grid');
            $cards = $grid.find('.mc-card');

            $countEl = $('#mc-count');

            $sortSel = $('#mc-sort');

            $descBanner = $('#mc-desc-banner');
            $descTitle = $descBanner.find('.main-collection__desc-title');
            $descText = $descBanner.find('.main-collection__desc-text');

            $emptyEl = $('#mc-empty');

            /* --------------------------------------------------
               REMOVE LOADING
            -------------------------------------------------- */

            $grid.removeClass('is-loading');

            /* --------------------------------------------------
               UPDATE ACTIVE BUTTON
            -------------------------------------------------- */

            $filterBtns.removeClass('mc-filter-btn--active')
                .attr('aria-pressed', 'false');

            $filterBtns.each(function () {

                if ($(this).data('collection') === url.split('/').pop()) {

                    $(this)
                        .addClass('mc-filter-btn--active')
                        .attr('aria-pressed', 'true');

                    currentFilter = ($(this).data('filter') || 'all')
                        .toString()
                        .toLowerCase()
                        .replace(/\s+/g, '-');
                }

            });

        if (currentFilter !== 'all') {
    applyFilter();
}

            /* --------------------------------------------------
               HISTORY
            -------------------------------------------------- */

            if (pushState) {

                history.pushState(
                    {
                        path: url
                    },
                    '',
                    url
                );

            }

            /* --------------------------------------------------
               SCROLL
            -------------------------------------------------- */

            $('html, body').animate({
                scrollTop: $('.main-collection').offset().top - 100
            }, 300);

        },

        error: function () {

            $grid.removeClass('is-loading');

            console.log('Collection load failed');

        }

    });

}

    /* ── Filter Button Click ─────────────────────────────── */
    $filterBtns.on('click', function (e) {

      e.preventDefault();

      var $btn = $(this);

      currentFilter = (
        $btn.data('filter') || 'all'
      )
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-');

      /* Active State */
      $filterBtns
        .removeClass('mc-filter-btn--active')
        .attr('aria-pressed', 'false');

      $btn
        .addClass('mc-filter-btn--active')
        .attr('aria-pressed', 'true');

      /* Mobile Close */
      if ($(window).width() <= 768) {

        $filterDrawer.removeClass('is-open');

        $filterToggle.attr(
          'aria-expanded',
          'false'
        );

      }

/* ── AJAX Collection Switch */
var collectionHandle = $btn.data('collection');

if (collectionHandle) {
    loadCollection('/collections/' + collectionHandle);
}

}); // <-- This closes $filterBtns.on('click', function(e) { ... })

/* ── Browser Back / Forward ──────────────────────────── */
window.addEventListener('popstate', function () {

    loadCollection(
        window.location.pathname,
        false
    );

});

    /* ── Mobile Filter Toggle ────────────────────────────── */
    $filterToggle.on('click', function () {

      var isOpen = $filterDrawer.hasClass('is-open');

      $filterDrawer.toggleClass('is-open');

      $(this).attr(
        'aria-expanded',
        isOpen ? 'false' : 'true'
      );

    });

    /* ── Outside Click ───────────────────────────────────── */
    $(document).on('click.aurieFilter', function (e) {

      if (
        $(window).width() <= 768 &&
        $filterDrawer.hasClass('is-open') &&
        !$(e.target).closest(
          '#mc-filters, #mc-filter-toggle'
        ).length
      ) {

        $filterDrawer.removeClass('is-open');

        $filterToggle.attr(
          'aria-expanded',
          'false'
        );

      }

    });

    /* ── Sort Select ─────────────────────────────────────── */
    $sortSel.on('change', function () {

      var val = $(this).val();

      clientSort(val);

      // applySort(val);

    });

/* ── Quick Add to cart ───────────────────────────────────── */
$section.on(
  'click',
  '.main-collection__card-quick[data-variant-id]',
  function (e) {

    e.preventDefault();
    e.stopPropagation();

    var $btn = $(this);

    var variantId = $btn.data('variant-id');

    if (
      $btn.prop('disabled') ||
      $btn.hasClass('is-loading')
    ) {
      return;
    }

    $btn
      .addClass('is-loading')
      .text('Adding…');

    $.ajax({

      type: 'POST',

      url: '/cart/add.js',

      data: JSON.stringify({
        id: variantId,
        quantity: 1
      }),

      contentType: 'application/json',

      dataType: 'json',

      success: async function () {

        $btn
          .removeClass('is-loading')
          .addClass('is-added')
          .text('Added ✓');

        /* Refresh Cart */
        document.dispatchEvent(
          new CustomEvent('cart:refresh')
        );

        $(document).trigger('cart:refresh');

        /* Open Cart Drawer */
        const cartDrawer =
          document.querySelector('cart-drawer');

        if (
          cartDrawer &&
          typeof cartDrawer.open === 'function'
        ) {

          cartDrawer.open();

        } else {

          /* Fallback Triggers */

          $(document).trigger('cart:open');

          document.dispatchEvent(
            new CustomEvent('cart:open')
          );

          const drawerTrigger =
            document.querySelector(
              '[data-cart-trigger], .header__icon--cart'
            );

          if (drawerTrigger) {
            drawerTrigger.click();
          }

        }

        setTimeout(function () {

          $btn
            .removeClass('is-added')
            .text('Quick Add');

        }, 2000);

      },

      error: function () {

        $btn
          .removeClass('is-loading')
          .text('Error — try again');

        setTimeout(function () {

          $btn.text('Quick Add');

        }, 2500);

      }

    });

  }
);
    /* ── Init ────────────────────────────────────────────── */
    applyFilter();

  });

})(jQuery);